import { render, staticRenderFns } from "./FeedbackEsc3Act2.vue?vue&type=template&id=4d20d743&"
var script = {}
import style0 from "./FeedbackEsc3Act2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports